const chartsTitles = {
  "AGR_EMI": "CO2 Emissions by Fuel",
  "AGR_FEC": "Agriculture Final Energy Consumption",
  "AGR_FuelPrice": "Fuel Price",
  "AGR_NRG-BIO-PRIME": "Primary Biomass from Agr./Forestry",
  "IND-CAF_FEC": "Chemicals and man-made fibers",
  "IND-CON_FEC": "Construction",
  "IND-EOE_FEC": "Electrical and optical equipment",
  "IND-FAB_FEC": "Food and beverages",
  "IND-MAE_FEC": "Machinery and equipment",
  "IND-MAP_FEC": "Basic metals and fabricated metal products",
  "IND-NEM_FEC": "Non-energy mining",
  "IND-OMA_FEC": "Other manufactuting",
  "IND-ONM_FEC": "Other non-metalic mineral products",
  "IND-PX4_FEC": "Pulp, paper, publishing and printing",
  "IND-RAP_FEC": "Rubber and plastic products",
  "IND-TAP_FEC": "Textiles and textile products",
  "IND-TEM_FEC": "Transport equipment manufacture",
  "IND-WAP_FEC": "Wood and wood products",
  "IND_EMI": "CO2 Emissions by Fuel",
  "IND_Emissions-CO2": "CO2 Emissions",
  "IND_FEC": "Industry Final Energy Consumption",
  "IND_FuelPrice": "Fuel Price",
  "PWR_Cap": "Installed Capacity",
  "PWR_Cap-N": "New Capacity",
  "PWR_Emissions-CO2": "CO2 Emissions",
  "PWR_FuelPrice": "Fuel Price",
  "PWR_Gen-ELCC": "Electricity Generation by PP",
  "PWR_Gen-HETC": "Heat Generation by PP",
  "RSD_BLD-N_TYPE": "New Dwellings by Type",
  "RSD_BLD_TYPE": "Number of Dwellings by Type",
  "RSD_CK_TYPE": "Cookers by Type",
  "RSD_EMI": "CO2 Emissions by Fuel",
  "RSD_FEC": "Residential Final Energy Consumption",
  "RSD_FuelPrice": "Fuel Price",
  "RSD_OtherServices_FuelCons": "Fuel Consumption for Other Services",
  "RSD_RTFT-APT_NCAP": "Retrofits in Apartments by Type",
  "RSD_RTFT-ATT_NCAP": "Retrofits in Attached by Type",
  "RSD_RTFT-DET_NCAP": "Retrofits in Detached by Type",
  "RSD_RTFT_NRG_SAVINGS": "Retrofit Energy Savings",
  "RSD_SC-N_FuelCons": "TFC New Space Cooling",
  "RSD_SC-N_TYPE": "New Space Cooling by Type",
  "RSD_Services_CO2Emissions": "CO2 Emissions by Service",
  "RSD_Services_EnergyCons": "Energy Consumption by Service",
  "RSD_WS-APT_FuelCons": "FC for Space/Water in Apartments",
  "RSD_WS-APT_NCAP": "New Space/Water in Apartments",
  "RSD_WS-ATT_FuelCons": "FC for Space/Water in Attached",
  "RSD_WS-ATT_NCAP": "New Space/Water in Attached",
  "RSD_WS-DET_FuelCons": "FC for Space/Water in Detached",
  "RSD_WS-DET_NCAP": "New Space/Water in Detached",
  "RSD_WaterSpace_FuelCons": "Fuel Consumption for Water and Space Heating",
  "SRV-COM_FEC_WS": "TFC - Commercial Space/Water Heating",
  "SRV-DCs_EH": "DC Total Excess Heat Potential",
  "SRV-DCs_EH_DH-Grid": "DC Excess Heat Supply to DH Grid",
  "SRV-PUB_FEC_WS": "TFC - Public Space/Water Heating",
  "SRV_EMI": "CO2 Emissions by Fuel",
  "SRV_FEC": "Services Final Energy Consumption",
  "SRV_FEC_COK": "TFC for Cooking",
  "SRV_FEC_DCs": "Data Centre Electricity Demand",
  "SRV_FEC_Service": "TFC by Service",
  "SRV_FuelPrice": "Fuel Price",
  "SUP_BIODST": "Biodiesel Supply by Source",
  "SUP_BIOETH": "Ethanol Supply by Source",
  "SUP_BIOGAS": "Biogas Supply by Source",
  "SUP_HYDROGEN": "Hydrogen Production",
  "SYS_CO2Price": "Marginal Emission Price",
  "SYS_Cost_Sector": "Annualised System Costs by Sector",
  "SYS_Cost_Type": "Annualised System Costs by Type",
  "SYS_DACS": "Unmitigated CO2/backstop",
  "SYS_Emissions_CH4": "CH4 Emissions by Sector",
  "SYS_Emissions_CO2": "CO2 Emissions by Sector",
  "SYS_Emissions_CO2_Domestic": "Domestic CO2 Emissions by Sector",
  "SYS_Emissions_CO2_Domestic_net": "Domestic Net CO2 Emissions by Sector",
  "SYS_Emissions_CO2_net": "Net CO2 Emissions by Sector",
  "SYS_Emissions_N2O": "N2O Emissions by Sector",
  "SYS_FEC-BIODST_Sector": "FEC of Biodiesel by Sector",
  "SYS_FEC-BIOETH_Sector": "FEC of Ethanol by Sector",
  "SYS_FEC-BIOGAS_Sector": "FEC of Biogas by Sector",
  "SYS_FEC-BIOWOOx_Sector": "FEC of Biomass by Sector",
  "SYS_FEC-COA_Sector": "FEC of Coal by Sector",
  "SYS_FEC-ELCD_Sector": "FEC of Electricity by Sector",
  "SYS_FEC-GASNAT_Sector": "FEC of Nat. Gas by Sector",
  "SYS_FEC-H2_Sector": "FEC of Hydrogen by Sector",
  "SYS_FEC-HETD_Sector": "FEC of Heat by Sector",
  "SYS_FEC-HFO_Sector": "FEC of HFO by Sector",
  "SYS_FEC-LPG_Sector": "FEC of LPG by Sector",
  "SYS_FEC-OILDST_Sector": "FEC of Diesel by Sector",
  "SYS_FEC-OILGSL_Sector": "FEC of Gasoline by Sector",
  "SYS_FEC-OILKER_Sector": "FEC of Kerosene by Sector",
  "SYS_FEC-PEAT_Sector": "FEC of Peat by Sector",
  "SYS_FEC_Fuel": " Final Energy Consumption by Fuel",
  "SYS_FEC_Fuel_2": "Final Energy Consumption by Fuel",
  "SYS_FEC_Sector": "Final Energy Consumption by Sector",
  "SYS_LumpInv_Sector": "Lump Sum Investment Cost by Sector",
  "SYS_NRG-Export": "Export",
  "SYS_NRG-Import": "Import",
  "SYS_NRG-Ind_Supply": "Indigenous Supply",
  "SYS_NRG-Mining": "Mining",
  "SYS_Share_Type": "Cost as share of GDP",
  "SYS_TPED": "Total Primary Energy Demand",
  "TRA-Land_LumpInv": "Land Transport - Lump Sum Investment Cost",
  "TRA_AVIDOM_FuelCons": "Fuel Consumption - Domestic Aviation",
  "TRA_AVIINT_FuelCons": "Fuel Consumption - International Aviation",
  "TRA_EMI": "CO2 Emissions by Fuel",
  "TRA_Emissions-CO2": "CO2 Emissions",
  "TRA_F-HTRUCK-N_TYPE": "New HGV - Stock by Type",
  "TRA_F-HTRUCK_TYPE": "HGV - Stock by Type",
  "TRA_F-LTRUCK-N_TYPE": "New LGV - Stock by Type",
  "TRA_F-LTRUCK_TYPE": "LGV - Stock by Type",
  "TRA_F-MTRUCK-N_TYPE": "New MGV - Stock by Type",
  "TRA_F-MTRUCK_TYPE": "MGV - Stock by Type",
  "TRA_FEC": "Transport Final Energy Consumption",
  "TRA_Freight_Land_FuelCons": "Fuel Consumption - Land Transport (F)",
  "TRA_Freight_Land_Mode": "Land Transport (F) by Mode",
  "TRA_FuelPrice": "Fuel Price",
  "TRA_NAV_FuelCons": "Fuel Consumption - Navigation",
  "TRA_OTH_FuelCons": "Fuel Consumption - Unspecified",
  "TRA_P-CAR-N_TYPE": "New Private Cars - Stock by Type",
  "TRA_P-CAR_TYPE": "Private Cars - Stock by Type",
  "TRA_Passenger_Land_Distance": "Land Transport (P) by Distance",
  "TRA_Passenger_Land_FuelCons": "Fuel Consumption - Land Transport (P)",
  "TRA_Passenger_Land_Mode": "Land Transport (P) by Mode",
  "TRA_Passenger_Land_Mode-L": "Land Transport (P) - Long",
  "TRA_Passenger_Land_Mode-M": "Land Transport (P) - Medium",
  "TRA_Passenger_Land_Mode-S": "Land Transport (P) - Short",
  "TRA_TURS_FuelCons": "Fuel Consumption - Tourism"
};

export default chartsTitles;
